import AdvancedTaskQuestionMode from "../types/dtos/forms/AdvancedTaskQuestionMode";

export function isViewOnlyMode(
  questionMode: AdvancedTaskQuestionMode | null | undefined
): boolean {
  return questionMode === "TASK-VIEW-ONLY";
}

/**
 * Hide the Optional chrome for ATM questions in view-only mode.
 * Defensive: missing config / mode must not throw; treat as show badge.
 */
export function shouldHideOptionalBadgeForViewOnlyAtm(
  questionType: string | null | undefined,
  questionMode: AdvancedTaskQuestionMode | null | undefined
): boolean {
  return (
    questionType === "ADVANCED-TASK-MANAGEMENT" && isViewOnlyMode(questionMode)
  );
}

export function usesCurrentTasksList(
  questionMode: AdvancedTaskQuestionMode | null | undefined
): boolean {
  return (
    questionMode === "TASK-CHECK-IN-ONLY" ||
    questionMode === "TASK-REVIEW-ONLY" ||
    questionMode === "TASK-VIEW-ONLY"
  );
}

export function allowsTaskCreation(
  questionMode: AdvancedTaskQuestionMode | null | undefined
): boolean {
  return (
    questionMode === "TASK-CHECK-IN-AND-CREATION" ||
    questionMode === "TASK-REVIEW-AND-CREATION" ||
    questionMode === "TASK-CREATION-ONLY"
  );
}

export function appliesExcludeCompletedBeforeJourney(
  questionMode: AdvancedTaskQuestionMode | null | undefined
): boolean {
  return (
    questionMode === "TASK-CHECK-IN-ONLY" ||
    questionMode === "TASK-CHECK-IN-AND-CREATION" ||
    questionMode === "TASK-VIEW-ONLY"
  );
}

/** Review modes for enforced-comment owner skip, weighting banner, must-close. */
export function isReviewQuestionMode(
  questionMode: AdvancedTaskQuestionMode | null | undefined
): boolean {
  return (
    questionMode === "TASK-REVIEW-ONLY" ||
    questionMode === "TASK-REVIEW-AND-CREATION"
  );
}

export function isSettingQuestionMode(
  questionMode: AdvancedTaskQuestionMode | null | undefined
): boolean {
  return (
    questionMode === "TASK-CREATION-ONLY" ||
    questionMode === "TASK-CHECK-IN-AND-CREATION" ||
    questionMode === "TASK-REVIEW-AND-CREATION"
  );
}

/**
 * Swapability "review" side: check-in and review modes. Does not include view-only.
 */
export function isSwapReviewQuestionMode(
  questionMode: AdvancedTaskQuestionMode | null | undefined
): boolean {
  return (
    questionMode === "TASK-CHECK-IN-ONLY" ||
    questionMode === "TASK-CHECK-IN-AND-CREATION" ||
    questionMode === "TASK-REVIEW-ONLY" ||
    questionMode === "TASK-REVIEW-AND-CREATION"
  );
}
